import { store } from 'pages/_app.page';

export const getStoreState = () => store.getState();
export const getStoreDispatch = () => store.dispatch;
